<script setup>
import { nextTick, watch } from 'vue';
import QRCode from 'qrcode';
import { useStorageStore } from '@/stores/storage';
import { storeToRefs } from 'pinia';

const { labels } = storeToRefs(useStorageStore());

let printed = false;

watch(labels, async (value) => {
    if (!value || printed) {
        return;
    }
    printed = true;
    await nextTick();

    const canvases = document.querySelectorAll('canvas[data-payload]');
    for (const canvas of canvases) {
        await QRCode.toCanvas(canvas, canvas.dataset.payload, {
            width: 160,
            margin: 1,
            errorCorrectionLevel: 'H',
        });
    }
    window.print();
}, { immediate: true });
</script>

<template>
<div
    v-if="labels"
    class="bg-white text-black p-6">
    <div class="grid grid-cols-3 gap-4">
        <div
            v-for="bin in labels.bins"
            :key="bin.payload"
            class="border border-black/40 rounded-lg p-4 flex flex-col items-center text-center break-inside-avoid">
            <canvas :data-payload="bin.payload" />
            <p class="font-mono font-bold text-lg mt-2">{{ bin.identifier }}</p>
            <p class="text-xs">{{ labels.storage_name }}</p>
        </div>
    </div>
</div>
</template>

<style scoped>
@media print {
    .break-inside-avoid {
        break-inside: avoid;
    }
}
</style>
